interface LoadingProps {
  fullScreen?: boolean
}

export default function Loading({ fullScreen }: LoadingProps) {
  return (
    <div className={`flex items-center justify-center ${fullScreen ? 'min-h-screen' : 'min-h-[200px]'}`}>
      <svg
        className="animate-spin"
        width="36"
        height="36"
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle cx="12" cy="12" r="10" stroke="#1A1A38" strokeWidth="3" />
        <path
          d="M12 2a10 10 0 0 1 10 10"
          stroke="#2E6BFF"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
    </div>
  )
}
